import { Directive, Input, OnInit, OnDestroy, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { RoleService } from '../../core/services/role.service';
import { UserRole } from '../../core/models/user.interface';

@Directive({
  selector: '[appHasRole]',
  standalone: true
})
export class HasRoleDirective implements OnInit, OnDestroy {
  private templateRef = inject(TemplateRef<any>);
  private viewContainer = inject(ViewContainerRef);
  private roleService = inject(RoleService);
  private destroy$ = new Subject<void>();
  
  private roles: UserRole[] = [];

  @Input() set appHasRole(roles: UserRole | UserRole[]) {
    this.roles = Array.isArray(roles) ? roles : [roles];
    this.updateView();
  }

  ngOnInit(): void {
    this.updateView();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateView(): void {
    if (this.roles.length === 0) {
      return;
    }

    this.roleService.hasAnyRole(this.roles)
      .pipe(takeUntil(this.destroy$))
      .subscribe(hasRole => {
        this.viewContainer.clear();
        if (hasRole) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        }
      });
  }
}


